/**
 * Constants for GenerateIAIconComponent
 */

export const GENERATE_IA_ICON_WEB_COMPONENT = 'generate-ia-icon-component';
